/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Коллекция для новостей
   */
  app.News = Backbone.PageableCollection.extend({
    
    fetchCounter: 0,
    
    mode: 'server',
    model: app.Model,
    
    url: function () {
      return app.entryScriptName + '/api/v3/news/';
    },
    
    categoryFilter: 'null',
    
    defaults: {
      category: 'null',
      pageSize: 10
    },
    
    state: {
      firstPage: 1,
      pageSize: 10
    },
    
    initialize: function (models, options) {
      if (options && options.defaults && _.isObject(options.defaults)) {
        _.extend(this.defaults, options.defaults);
      }
      Backbone.PageableCollection.prototype.initialize.apply(this, arguments);
      this.categories = new app.Collection();
      this.categories.reset(JSON.parse($('#categories-json').text()));
      this.setQueryParams();
    },
    
    setQueryParams: function () {
      var that = this;
      this.queryParams = {
        currentPage: 'page',
        pageSize: 'per-page',
        totalPages: 'page_count',
        category_id: function () {
          var value = [];
          _.each(that.categoryFilter.split(','), function (val) {
            var category = that.categories.findWhere({slug: val});
            if (category) {
              value.push(category.get('id'));
            }
          });
          return value.join(',');
        }
      };
      
      this.queryParams.expand = 'thumbnail_url,news_url,categories,name';
    },
    
    /**
     * Заполнение коллекции категории моделями товаров.
     * @param resp
     * @param options
     * @returns {object} Models
     */
    parseRecords: function (resp, options) {
      var that = this;
      return _.map(resp.items, function (obj) {
        obj.created_at = app.helpers.DateHelper.asSocialDate(obj.created_at, 'DD.MM.YYYY');
        obj.published_at = app.helpers.DateHelper.asSocialDate(obj.published_at, 'DD.MM.YYYY');
        return new that.model(obj, options);
      });
    },
    
    parseState: function (resp) {
      return {
        totalRecords: resp._meta.totalCount,
        itemsInResponse: resp.items.length
      };
    },
    
    /**
     * Переопределяем родной fetch коллекции, чтобы считать количество
     * @param {Object} options
     * @returns {*|XMLHttpRequest}
     */
    fetch: function (options) {
      this.fetchCounter += 1;
      return Backbone.PageableCollection.prototype.fetch.apply(this, [options]);
    },
    
    /**
     * Устанавливает фильтр по категории
     */
    setCategoryFilter: function (filter) {
      this.categoryFilter = filter;
    }
  });
  
})();

}.call(window));